import React from 'react';
import { Box, Typography } from '@mui/material';
import GetAppOutlined from '@mui/icons-material/GetAppOutlined';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import { getDocumentType } from '../../../Services/Content/Content';
import ThemableButton from '../../../theme/components/Button/ThemableButton';

interface Props {
  downloadable?: boolean;
  onDownload?: () => void;
  mime: string;
}

const PDFError: React.FC<Props> = (props: Props): JSX.Element => {
  const { downloadable = false, onDownload, mime } = props;

  return (
    <Box alignItems="center" display="flex" flexDirection="row">
      <InsertDriveFile color="secondary" style={{ fontSize: 80 }} />
      <Box>
        <Typography color="textSecondary" component="p" variant="body2">
          <Box component="strong">Format:</Box>{' '}
          {getDocumentType(mime, 'Unknown')}
        </Typography>
        {downloadable && (
          <ThemableButton
            aria-label="Download"
            onClick={onDownload}
            size="small"
            startIcon={<GetAppOutlined />}
            variant="text"
          >
            Download
          </ThemableButton>
        )}
      </Box>
    </Box>
  );
};

export default PDFError;
